import WhatsAppTemplatesView from '../WhatsAppTemplatesView.vue'
import TemplateListPage from '../Pages/TemplateListPage.vue'

// DEF-ADM-025 — catálogo de plantillas de WhatsApp y su asignación por ciudad.
// Vive en Administración: es configuración global, no depende de la ciudad activa.
const routes = [
  {
    path: '/administracion/plantillas-whatsapp',
    component: WhatsAppTemplatesView,
    name: 'whatsapp-templates',
    children: [
      {
        path: '',
        name: 'whatsapp-template-list',
        component: TemplateListPage
      }
    ]
  }
]

export default routes
